import "./App.css";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrivateRoute from "./routes/PrivateRoute";
import PublicRoute from "./routes/PublicRoute";
import LoginForm from "./components/Auth/LoginForm";
import AdminLayout from "./components/Admin/AdminLayout";
import UserManagement from "./components/Admin/UserManagement";
import QuestionBankManagement from "./components/Admin/QuestionBankManagement";
import { ThemeProvider, createTheme } from "@mui/material/styles";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route element={<PrivateRoute />}>
        <Route element={<AdminLayout />}>
          <Route path="/admin/users" element={<UserManagement />} />
          <Route path="/admin/questions" element={<QuestionBankManagement />} />
          <Route path="/" element={<Navigate to="/admin/users" replace />} />
          <Route
            path="/admin"
            element={<Navigate to="/admin/users" replace />}
          />
        </Route>
      </Route>
      <Route element={<PublicRoute />}>
        <Route path="/login" element={<LoginForm />} />
      </Route>
    </Route>
  )
);

const theme = createTheme({
  typography: {
    fontFamily: '"Times New Roman", "Times", serif',
  },
});
function App() {
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <RouterProvider router={router} />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </ThemeProvider>
  );
}

export default App;
